var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"application--linear-gradient"},[_c('v-content',[_c('router-view',{on:{"lock-screen":_vm.lockScreen,"snackbar-note":_vm.showSnackbarNote}})],1),_c('NavigationMenu',{on:{"snackbar-note":_vm.showSnackbarNote}}),_c('ScreenLocker',{attrs:{"show":_vm.screenLocker}}),_c('SnackbarNote',{attrs:{"options":_vm.snackbarNote}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }